import React, {Component} from "react";
import "./SideloadUpload.css"
import Api from "../../api/Api";
import {toast} from "react-toastify";
import Authentication from "../../authentication/Authentication";


export default class SideloadUpload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedFiles: [],
            fileType: "images",
            showVerification: false,
            showConfirm: false,
            input: "",
            targetPath: "",
            uploading: false,
            restarting: false,
            showRestartMessage: false,
            showTooltip: false,
            showErrorMessage: false
        };

        this.authentication = new Authentication();
    };

    handleFileChange = (e) => {
        this.setState({
            selectedFiles: Array.from(e.target.files)
        })
    }

    handlePost(timer) {
        if (timer) {
            clearTimeout(timer)
            console.log(timer)
        }
        this.setState({
            uploading: false,
            targetPath: "",
            selectedFiles: []

        })
    }

    handleError(error) {
        console.log(error)
        this.setState({
            showErrorMessage: true,
            uploading: false,
            targetPath: "",
            selectedFiles: []
        })
    }

    usePreSignedPost = (url, fileName) => {
        const file = this.state.selectedFiles.filter((file) => file.name === fileName)[0]

        const params = {
            Key: `${this.state.targetPath}/${file.name}`,
            ContentType: file.type,
            ACL: 'public-read'
        }

        const formData = new FormData()
        Object.keys(params).forEach((key) => {
            formData.append(key, params[key]);
        });
        formData.append('file', file);

        const timer = setTimeout(() => {
            this.setState({
                showErrorMessage: true,
                uploading: false,
                targetPath: "",
                selectedFiles: []
            })
        }, 60000)

        fetch(url.url, {
            method: 'POST',
            body: formData
        }).then(() => this.handlePost(timer)).catch((error) => this.handleError(error))
    }

    handleUploadClick = (e) => {
        e.preventDefault()

        this.setState({
            uploading: true
        })

        const api = new Api()

        this.state.selectedFiles.forEach(file => {
            const fileName = file.name

            if (this.authentication.isAdmin()) {
                api.pisaasCreateS3PresignedPost(this.usePreSignedPost, function (err) {
                    console.log(err);
                    toast.error("Failed to fetch Pisaas Instances", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }, this.props.domain, fileName, "pisaas-resource-upload", this.props.region, this.state.targetPath);
            }
        })
    }

    restartCallback = () => {
        this.setState({
            restarting: false,
            showRestartMessage: true
        })
    }

    handleRestart = () => {
        this.setState({
            restarting: true,
            showConfirm: false,
            showVerification: false
        })
        const api = new Api()

        if (this.authentication.isAdmin()) {
            api.pisaasRestartDashboard(this.restartCallback, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.domain, this.props.region);
        }
    }

    handleFileInputChange = (e) => {
        this.setState({
            targetPath: e.target.value
        })
    }

    handleInputChange(event, event_tag) {
        event.preventDefault();

        if (event.target.value === "confirm") {
            this.setState({
                input: event.target.value,
                showConfirm: true
            })
        } else {
            this.setState({
                input: event.target.value,
                showConfirm: false
            })
        }
    }

    renderConfirm = () => {
        return (
            <div className="restart-dashboard-verification">
                <span className="try-pi-verification-title">Restart Dashboard: </span>
                <div className="try-pi-verification-form-element">
                        <span className="try-pi-verification-instructions">Type 'confirm' to restart dashboard:<input
                            placeholder={"confirm"} value={this.state.input}
                            onInput={(event) => this.handleInputChange(event, "some stuff")}
                            className="try-pi-verification-input"/></span>
                </div>
                {this.state.showConfirm ?
                    <button className={"btn-confirm"} onClick={() => this.handleRestart()}>Confirm</button> : <></>}
                <button className={"btn-cancel"} onClick={() => this.setRenderConfirm()}>Cancel</button>
            </div>
        )
    }

    setRenderConfirm = () => {
        this.setState({
            showVerification: !this.state.showVerification
        })
    }

    render() {
        return (
            <div className={"pisaas-sideload-popup-container"} data-testid="config.sideloading.upload.popup">
                <div className={"sideload-box"}>
                    <div>
                        <button className="try-pi-btn config-close-button" data-testid="config.sideloading.upload.button.close" onClick={() => this.props.togglePopUp()}>X
                        </button>
                    </div>
                    <h2 className={"sideload-header"} data-testid="config.sideloading.upload.header">Select files to upload</h2>
                    <div className={"sideload-upload-container"} data-testid="config.sideloading.upload.container">
                        <div className={"help-info"}>
                            <p className={"upload-text"} data-testid="config.sideloading.upload.text">Upload files for a target destination on your instance file system, for svg, images, custom jdbc and themes.</p>
                            <div className="upload-tooltip" data-testid="config.sideloading.upload.tooltip">
                                <i className="fa fa-info-circle upload-info" aria-hidden="true"></i>
                                <p className={"upload-tooltiptext"} data-testid="config.sideloading.upload.tooltip.text">Examples: <br/>/{this.props.domain}/svg<br/>/{this.props.domain}/themes<br/>/{this.props.domain}/themes/newTheme - (creates new theme folder)<br/>/{this.props.domain}/themes/newTheme/img<br/></p>
                            </div>
                        </div>
                        <p className={"upload-text"} data-testid="config.sideloading.upload.text">If uploading a custom jdbc the dashboard will need restarting to load it onto your instance.</p>
                        <label
                            className={"sideload-choose-file-button"} data-testid="config.sideloading.upload.button.browseFiles">{this.state.selectedFiles.length === 0 ? "Click here to browse files" : this.state.selectedFiles.map(file => {
                            return (
                                <p>{file.name}</p>
                            )
                        })}
                            <input hidden className={"sideload-input"} type={"file"}
                                   accept={"image/*, .svg, .css, .json, .ico, .jar"}
                                   onChange={(e) => this.handleFileChange(e)} multiple/>
                        </label>
                        <input value={this.state.targetPath} onChange={(e) => this.handleFileInputChange(e)}
                               type={"text"} className={"sideload-input"}
                               data-testid="config.sideloading.upload.input.targetPath"
                               placeholder={"Please provide full target path"}/>

                        {this.state.uploading ? <i className="fa fa-spinner fa-pulse fa-3x fa-fw upload-load"/> : <button className={"sideload-upload-button"} data-testid="config.sideloading.upload.button.upload" onClick={(e) => this.handleUploadClick(e)}>Upload
                        </button>}
                        {this.state.showErrorMessage ? <p className={"error-message"} data-testid="config.sideloading.upload.error">Something has gone wrong when uploading your files. Please check the file and target path entered.</p> : <></>}
                        {this.state.restarting ? <i className="fa fa-spinner fa-pulse fa-3x fa-fw upload-load"/> : this.state.showRestartMessage ? <p className={"restart-message"} data-testid="config.sideloading.upload.message">Dashboard is restarting. This can take a few minutes.</p> : <button className={"sideload-restart-button"} data-testid="config.sideloading.upload.button.restart" onClick={(e) => this.setRenderConfirm(e)}>Restart
                            Dashboard
                        </button>}
                        {this.state.showVerification ? this.renderConfirm() : <></>}
                    </div>
                </div>
            </div>
        )
    }
}



